import React, {useEffect} from 'react';
import {createRoot} from "react-dom/client";
import YearbookSearchFacets from "./components/yearbookSearchFacets/yearbookSearchFacets";
import YearbookSearchPaginator from "./components/yearbookSearchPaginator/yearbookSearchPaginator";
import YearbookSearchField from "./components/yearbookSearchField/yearbookSearchField";
import YearbookSearchList from "./components/yearbookSearchList/yearbookSearchList";

import "./yearbookSearch.scss";
import '../i18n';
import i18next from "i18next";
import {Provider, useSelector} from "react-redux";
import store from "./store/store";
import {yearbookSearchApi} from "./services/yearbookSearchService";



const facetsLookup = [
    'typename',
    'lang_code',
    'recurrence_volume',
    'recurrence_year',
];


const rootElement = document.getElementById("yearbook-search");
const searchURI = rootElement.getAttribute("data-searchURI")
const root = createRoot(document.getElementById("yearbook-search"));

const YearbookSearch = () => {

    // const lang_code = i18next.language;
    // const term = useSelector(getTerm);
    // const page = useSelector(getPage);
    // const fields  = useSelector(getFields);
    // const facets = useSelector(getFacets);

    const searchTerm = useSelector(state => state.yearbookSearch.term);
    const page = useSelector(state => state.yearbookSearch.page);
    const perPage = useSelector(state => state.yearbookSearch.perPage);
    const fields = useSelector(state => state.yearbookSearch.fields);
    const facets = useSelector(state => state.yearbookSearch.facets);
    const exactSearch = useSelector(state => state.yearbookSearch.exactSearch);

    const [trigger, { data, error, isLoading, isUninitialized }] = yearbookSearchApi.endpoints.getYearbooks.useLazyQuery();

    useEffect(() => {
        trigger({
            page: page,
            perPage: perPage,
            facets: facets,
            exactSearch: exactSearch,
            queryFields: fields,
            searchTerm: searchTerm
        });
    }, [searchTerm, page, fields, facets, exactSearch]);

    // connect the sidebar button
    // useEffect(() => {
    //     const sidebar = document.querySelector('.chapter-sidebar');
    //     const sidebarOffCanvas = new bootstrap.Offcanvas(sidebar, {backdrop: false, scroll: true});
    //     document.querySelector('.sidebar-toggle').addEventListener('click', function(event) {
    //         event.preventDefault();
    //         sidebarOffCanvas.toggle();
    //     });
    // });

    const isInit = (searchTerm, data) => {
        return searchTerm === '' && (data ? data.paginator.total_count === 0 : false);
    }

    return (
        <div>
            <div className={'py-5'}>
                <YearbookSearchField></YearbookSearchField>
            </div>
            {
                isInit(searchTerm, data) ? <div className={'pb-5'}>
                        <div>{i18next.t('yearbook.search_placeholder', 'Enter a search term')}</div>
                    </div> :
                    <div>
                        <h3 className={'pb-5'}>{data?.paginator.total_count} {i18next.t('yearbook.pages_found', 'pages found')}</h3>
                <div className={'d-flex flex-row row gx-5'}>
                    <div className={'col d-flex flex-column justify-content-between'}>
                        <YearbookSearchList props={{data}}></YearbookSearchList>
                        <YearbookSearchPaginator props={{data, page}}></YearbookSearchPaginator>
                    </div>
                    <YearbookSearchFacets props={{data}}></YearbookSearchFacets>
                </div>
            </div>
            }
        </div>
    )
}

export default YearbookSearch;

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <YearbookSearch />
        </Provider>
    </React.StrictMode>
);

